// Superadmin store
// --------------------------------------------------------
import Vue from 'vue'
import {Endpoints} from '@/lib/definitions'
import api from '@/lib/api'

const state = {
  allLandscapes: null,
  allUsers: null
}
const getters = {
  allLandscapes: state => state.allLandscapes,
  allUsers: state => state.allUsers
}
const mutations = {
  setAllLandscapes(state, landscapes) {
    state.allLandscapes = landscapes
  },
  setAllUsers(state, users) {
    state.allUsers = users
  },
  flipFlags(state, slug) {
    const landscape = state.allLandscapes.find(lndscp => lndscp.slug === slug)
    if (landscape) {
      const flippedFlag = !landscape.belongs
      Vue.set(landscape, 'belongs', flippedFlag) // add reactivity
      landscape.admin = landscape.superadmin = flippedFlag
    }
  },
  setAdmin(state, data) {
    const landscape = state.allLandscapes.find(
      lndscp => lndscp.slug === data.slug
    )
    if (landscape) {
      landscape.admin = data.admin
    }
  }
}

const actions = {
  resetAllMentions: ({getters, commit}) => {
    const landscapeId = getters.currentLandscape._id
    return api
      .call(
        'post',
        `${Endpoints.SUPERADMIN}/landscapes/${landscapeId}/mentions/reset`
      )
      .then(() => {
        commit('unreadAllMentions', getters.mentions)
        commit('updateMentionCount', {
          landscapeId,
          set: getters.mentions.length
        })
      })
  },
  loadAllLandscapes: context => {
    return api
      .call('get', `${Endpoints.SUPERADMIN}/listLandscapes`)
      .then(landscapes => {
        context.commit('setAllLandscapes', landscapes)
        return landscapes
      })
  },
  loadAllUsers: context => {
    return api
      .call('get', `${Endpoints.SUPERADMIN}/listLandscapes`)
      .then(users => {
        context.commit('setAllUsers', users)
        return users
      })
  },
  addOrDropLandscape: (context, payload) => {
    const email = payload.email
    const slug = payload.slug
    return api
      .call(
        'post',
        `${Endpoints.SUPERADMIN}/${payload.action}/${email}/${slug}`
      )
      .then(user => {
        context.commit('setLandscapes', user)
        context.commit('flipFlags', slug)
        return user
      })
  },
  dropFromLandscape: (context, payload) => {
    payload.action = 'dropFromLandscape'
    return context.dispatch('addOrDropLandscape', payload)
  },
  addToLandscape: (context, payload) => {
    payload.action = 'addToLandscape'
    return context.dispatch('addOrDropLandscape', payload)
  },
  patchSuperadminLandscape: (context, payload) => {
    const email = payload.email
    const slug = payload.slug
    return api.call(
      'patch',
      `${Endpoints.SUPERADMIN}/superadminLandscape/${email}/${slug}`,
      payload.body
    )
  },
  setAdminLandscape: (context, payload) => {
    payload.body = {admin: payload.admin}
    return context
      .dispatch('patchSuperadminLandscape', payload)
      .then(() => context.commit('setAdmin', payload))
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
